"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _cookies = require("@kiwicom/cookies");
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _Radio = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Radio"));
var _Text3 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _Separator2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Separator"));
var _List = _interopRequireWildcard(require("@kiwicom/orbit-components/lib/List"));
var _Modal = require("@kiwicom/orbit-components/lib/Modal");
var _Cookie2 = _interopRequireDefault(require("./Cookie"));
var _context = require("../../../../../services/log/context");
var _events = require("../../../consts/events");
var _context2 = require("../../../../../services/intl/context");
var _jsxRuntime = require("react/jsx-runtime");
var _ModalHeader, _Separator, _Cookie, _FormattedMessage, _FormattedMessage2, _FormattedMessage3, _FormattedMessage4, _FormattedMessage5, _FormattedMessage6, _FormattedMessage7, _FormattedMessage8, _Text, _Text2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CookiesForm = () => {
  const {
    log
  } = (0, _context.useLog)();
  const {
    settings,
    onAgree,
    onChange
  } = (0, _cookies.useCookies)();
  const {
    language
  } = (0, _context2.useIntl)();
  const [form, setForm] = React.useState(settings);
  const handleChange = React.useCallback(ev => {
    const event = ev;
    const {
      target
    } = event;
    setForm(state => ({
      ...state,
      [target.name]: target.value === "1"
    }));
  }, []);
  const handleSave = React.useCallback(() => {
    onAgree(true);
    onChange(form);
    log(_events.COOKIE_CONSENT_ACCEPTED, form);
  }, [onAgree, onChange, form, log]);
  const handleAccept = React.useCallback(() => {
    onAgree(true);
    onChange({
      analytics: true,
      marketing: true
    });
    setForm(() => ({
      analytics: true,
      marketing: true
    }));
    log(_events.COOKIE_CONSENT_ACCEPTED, {
      analytics: true,
      marketing: true
    });
  }, [onAgree, onChange, log]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_ModalHeader || (_ModalHeader = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalHeader, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "content.cookies_settings.general.title"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.ModalSection, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
        type: "secondary",
        spaceAfter: "large",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "content.cookies_settings.general.content.v2",
          values: {
            a1: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              href: `/${language.id}/pages/content/privacy`,
              children: text
            }),
            a2: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              href: `/${language.id}/pages/content/privacy#cookies`,
              children: text
            })
          }
        })
      }), _Separator || (_Separator = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator2.default, {
        spaceAfter: "medium"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spaceAfter: "large",
        children: [_Cookie || (_Cookie = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cookie2.default, {
          category: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.necessary.title"
          }),
          description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.necessary.description"
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
            spaceAfter: "large",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
              label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.enabled"
              }),
              checked: true,
              disabled: true
            })
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cookie2.default, {
          category: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.performance.title"
          })),
          description: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.performance.description"
          })),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            inline: true,
            spaceAfter: "large",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
              label: _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.enabled"
              })),
              checked: form.analytics,
              name: "analytics",
              value: "1",
              onChange: handleChange
            }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
              label: _FormattedMessage4 || (_FormattedMessage4 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.disabled"
              })),
              checked: !form.analytics,
              name: "analytics",
              value: "0",
              onChange: handleChange
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Cookie2.default, {
          category: _FormattedMessage5 || (_FormattedMessage5 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.marketing.title"
          })),
          description: _FormattedMessage6 || (_FormattedMessage6 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "content.cookies_settings.marketing.description"
          })),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.default, {
            size: "small",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_List.ListItem, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.marketing.description.marketing",
                values: {
                  strong: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                    children: text
                  }),
                  companyName: "Kiwi.com"
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.ListItem, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.marketing.description.advertisement",
                values: {
                  strong: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                    children: text
                  })
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.ListItem, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.marketing.description.facebook",
                values: {
                  strong: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                    children: text
                  }),
                  companyName: "Kiwi.com"
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.ListItem, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.marketing.description.lookalike",
                values: {
                  strong: text => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                    children: text
                  })
                }
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
            inline: true,
            spaceAfter: "large",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
              label: _FormattedMessage7 || (_FormattedMessage7 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.enabled"
              })),
              checked: form.marketing,
              name: "marketing",
              value: "1",
              onChange: handleChange
            }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
              label: _FormattedMessage8 || (_FormattedMessage8 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "content.cookies_settings.general.disabled"
              })),
              checked: !form.marketing,
              name: "marketing",
              value: "0",
              onChange: handleChange
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.ModalFooter, {
      flex: "1 0 100%",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        direction: "row",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          onClick: handleSave,
          type: "secondary",
          fullWidth: true,
          children: _Text || (_Text = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
            weight: "bold",
            align: "center",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "content.cookies_settings.general.save_settings"
            })
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          onClick: handleAccept,
          fullWidth: true,
          children: _Text2 || (_Text2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text3.default, {
            type: "white",
            weight: "bold",
            align: "center",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "content.cookies_settings.general.accept_all"
            })
          }))
        })]
      })
    })]
  });
};
var _default = CookiesForm;
exports.default = _default;